// 将 data/examples/*.json 中的相对图片路径（data/images/...）
// 转换为可在运行时访问的公开路径（/data/images/...）
export function toPublicImagePath(path: string): string {
  if (!path) return path
  if (path.startsWith('http')) return path
  // 允许以 data/images 或 /data/images 开头
  const clean = path.replace(/^\/*/, '')
  if (clean.startsWith('data/images')) return '/' + clean
  return '/' + clean
}